import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isNative } from 'styles';
import { numbers } from 'app/utils';
import Thumb from './thumb.component';
import { View, styled } from 'modules/styled';

const Container = styled(View)({
  position: isNative == true ? 'absolute' : 'fixed',
  zIndex: 10000,
  left: 0,
  top: 0,
  right: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export default function DownvoteAnimation() {
  const [animEls, setAnimEls] = useState({});

  const { index, parent } = useSelector((state) => state.animation.downvote || {});

  function destroy(key) {
    setAnimEls((els) => {
      const { [key]: removeEl, ...newEls } = els;
      return newEls;
    });
  }

  useEffect(() => {
    function runAnimation() {
      if (!parent) return;
      const key = numbers.guid();
      const newEl = {
        [key]: <Thumb destroy={destroy} parent={parent} key={key} id={key} />,
      };
      setAnimEls((els) => ({ ...els, ...newEl }));
    }
    runAnimation();
  }, [index, parent]);

  return <Container pointerEvents={'none'}>{Object.values(animEls)}</Container>;
}
